import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

import versionWeb from '../../assets/version.json';

const CHECK_INTERVAL_MS = 60_000;

export const useVersionCheck = () => {
  const notified = useRef(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const check = async () => {
      if (notified.current) {
        return;
      }
      try {
        const res = await fetch(`/assets/version.json?t=${Date.now()}`);
        if (!res.ok) {
          return;
        }
        const remote = (await res.json()) as { buildTime?: string };
        if (remote.buildTime && remote.buildTime !== versionWeb.buildTime) {
          notified.current = true;
          if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          toast.info(
            'Dostępna jest nowa wersja aplikacji. Odśwież stronę, aby ją załadować.',
            {
              autoClose: false,
              closeOnClick: false,
              draggable: false,
              onClick: () => window.location.reload(),
              toastId: 'new-version',
            },
          );
        }
      } catch {
        // sieć niedostępna — ignorujemy
      }
    };

    void check();
    intervalRef.current = setInterval(() => void check(), CHECK_INTERVAL_MS);
    return () => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
};
